/* =========================================================
   QUOTE FORM — contact page only
   File uploads -> Firebase Storage (mailer-3dpm), then JSON
   POST to the submitQuote Cloud Function. Unchanged from the
   original site.js pipeline. The 'mailer' Firebase app is
   initialized in theme.js.
   ========================================================= */
(function () {
  var form = document.getElementById('quote-form');
  if (!form) return;

  document.querySelectorAll('[data-radio-group] .form__radio').forEach(function (label) {
    var input = label.querySelector('input');
    input.addEventListener('change', function () {
      label.classList.toggle('form__radio--active', input.checked);
    });
  });

  var submitBtn = document.getElementById('form-submit');
  var successEl = document.getElementById('form-success');

  function setError(id, on) {
    var wrap = document.getElementById(id).closest('.field');
    wrap.classList.toggle('field--error', on);
  }
  function validEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v.trim()); }

  /* File drop + picker */
  var drop = document.getElementById('filedrop');
  var fileInput = document.getElementById('f-file');
  var fileList = document.getElementById('filedrop-list');
  var fileErr = document.getElementById('file-err');
  var MAX_PER_FILE = 25 * 1024 * 1024;
  var files = [];

  function fmtSize(b) {
    if (b < 1024) return b + ' B';
    if (b < 1024 * 1024) return (b / 1024).toFixed(0) + ' KB';
    return (b / 1024 / 1024).toFixed(1) + ' MB';
  }

  function renderFiles() {
    fileList.innerHTML = '';
    files.forEach(function (f, i) {
      var li = document.createElement('li');
      li.innerHTML =
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>' +
        '<span class="file-name" title="' + f.name + '">' + f.name + '</span>' +
        '<span class="file-size">' + fmtSize(f.size) + '</span>' +
        '<button type="button" aria-label="Remove" data-remove="' + i + '"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></button>';
      fileList.appendChild(li);
    });
  }

  function addFiles(list) {
    if (fileErr) { fileErr.textContent = ''; fileErr.closest('.field').classList.remove('field--error'); }
    [].slice.call(list).forEach(function (f) {
      if (f.size > MAX_PER_FILE) {
        if (fileErr) {
          fileErr.textContent = '"' + f.name + '" is over 25 MB — email it to info@3dprintmaster.co.';
          fileErr.closest('.field').classList.add('field--error');
        }
        return;
      }
      if (files.some(function (x) { return x.name === f.name && x.size === f.size; })) return;
      files.push(f);
    });
    renderFiles();
  }

  if (drop && fileInput) {
    fileInput.addEventListener('change', function (e) { addFiles(e.target.files); });
    ['dragenter', 'dragover'].forEach(function (ev) {
      drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('filedrop--over'); });
    });
    ['dragleave', 'drop'].forEach(function (ev) {
      drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('filedrop--over'); });
    });
    drop.addEventListener('drop', function (e) {
      if (e.dataTransfer && e.dataTransfer.files.length) addFiles(e.dataTransfer.files);
    });
    fileList.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-remove]');
      if (!btn) return;
      files.splice(+btn.dataset.remove, 1);
      renderFiles();
    });
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var name = document.getElementById('f-name').value.trim();
    var email = document.getElementById('f-email').value.trim();
    var project = document.getElementById('f-project').value.trim();

    var errs = { 'f-name': name.length < 1, 'f-email': !validEmail(email), 'f-project': project.length < 8 };
    Object.keys(errs).forEach(function (id) { setError(id, errs[id]); });
    if (Object.keys(errs).some(function (k) { return errs[k]; })) {
      document.getElementById(Object.keys(errs).find(function (k) { return errs[k]; })).focus();
      return;
    }

    var phone = (document.getElementById('f-phone') ? document.getElementById('f-phone').value : '').trim();
    var prefer = Array.prototype.slice.call(form.querySelectorAll('input[name="prefer"]:checked')).map(function (i) { return i.value; });
    var service = Array.prototype.slice.call(form.querySelectorAll('input[name="service"]:checked')).map(function (i) { return i.value; });

    var labelEl = submitBtn.querySelector('.btn__label');
    var arrowEl = submitBtn.querySelector('.btn__arrow');
    var originalLabel = labelEl.textContent;
    submitBtn.disabled = true;
    var phases = ['Sending', 'Sending.', 'Sending..', 'Sending...'];
    var phase = 0;
    labelEl.textContent = phases[0];
    arrowEl.textContent = '...';
    var iv = setInterval(function () { phase = (phase + 1) % phases.length; labelEl.textContent = phases[phase]; }, 380);

    (function () {
      var submissionId = (window.crypto && crypto.randomUUID)
        ? crypto.randomUUID()
        : (Date.now() + '-' + Math.random().toString(36).slice(2, 10));

      function uploadAll() {
        var uploaded = [];
        if (files.length === 0 || typeof firebase === 'undefined' || !firebase.storage) {
          return Promise.resolve(uploaded);
        }
        var mailerApp = firebase.apps.find(function (a) { return a.name === 'mailer'; });
        var storage = mailerApp ? mailerApp.storage() : firebase.storage();
        var chain = Promise.resolve();
        files.forEach(function (f) {
          chain = chain.then(function () {
            var safeName = f.name.replace(/[^\w.\-]+/g, '_');
            var ref = storage.ref('quote-uploads/' + submissionId + '/' + safeName);
            var uploadPromise = ref.put(f).then(function (snap) { return snap.ref.getDownloadURL(); });
            var timeoutPromise = new Promise(function (_, rej) {
              setTimeout(function () { rej(new Error('File upload timed out — ' + f.name)); }, 30000);
            });
            return Promise.race([uploadPromise, timeoutPromise]).then(function (url) {
              uploaded.push({ name: f.name, url: url, size: f.size });
            });
          });
        });
        return chain.then(function () { return uploaded; });
      }

      uploadAll().then(function (uploaded) {
        var payload = { name: name, email: email, phone: phone, prefer: prefer, service: service, project: project, files: uploaded };
        return fetch('https://us-central1-mailer-3dpm.cloudfunctions.net/submitQuote', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });
      }).then(function (res) {
        if (!res.ok) {
          return res.text().catch(function () { return ''; }).then(function (txt) {
            throw new Error('submitQuote failed: ' + res.status + ' ' + txt);
          });
        }
        clearInterval(iv);
        successEl.classList.add('form__success--show');
        labelEl.textContent = '✓ Sent';
        arrowEl.textContent = '';
        form.reset();
        files.length = 0;
        renderFiles();
        successEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(function () {
          submitBtn.disabled = false;
          labelEl.textContent = originalLabel;
          arrowEl.textContent = '→';
        }, 6000);
      }).catch(function (err) {
        console.warn('Quote submit failed:', err);
        clearInterval(iv);
        submitBtn.disabled = false;
        labelEl.textContent = 'Try again';
        arrowEl.textContent = '→';
        alert('Sorry — something went wrong sending your request. Please try again, or email us directly at orders@3dprintmaster.co.');
        setTimeout(function () { labelEl.textContent = originalLabel; }, 4000);
      });
    })();
  });

  ['f-name', 'f-email', 'f-project'].forEach(function (id) {
    var el = document.getElementById(id);
    el.addEventListener('input', function () { setError(id, false); });
  });
})();
